"use strict";

/* -------------------------------------------------------------------------

	PUNITED.animation

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
var createjs, AdobeAn; // グローバル名前空間定義

var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.animation) PUNITED.animation = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.animation;

  ns.triangle = function (container) {
    (function (cjs, an) {
      var p; // shortcut to reference prototypes

      var lib = {};
      var ss = {};
      var img = {};
      lib.ssMetadata = [];
      (lib.AnMovieClip = function () {
        this.actionFrames = [];
        this.ignorePause = false;

        this.gotoAndPlay = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
        };

        this.play = function () {
          cjs.MovieClip.prototype.play.call(this);
        };

        this.gotoAndStop = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
        };

        this.stop = function () {
          cjs.MovieClip.prototype.stop.call(this);
        };
      }).prototype = p = new cjs.MovieClip(); // symbols:
      // helper functions:

      function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));

        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
      }

      function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
      }

      (lib.yellow_t = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FCC800").s().p("ALu0SIAASLIntNUIvuJGg");
        this.shape.setTransform(75.025, 129.925);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.yellow_t, new cjs.Rectangle(0, 0, 150.1, 259.9), null);
      (lib.green_t = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#75BE00").s().p("A3bEjIPwpFIPYAAIPvJFg");
        this.shape.setTransform(150, 29.1);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.green_t, new cjs.Rectangle(0, 0, 300, 58.2), null);
      (lib.blue_t = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#00A8DB").s().p("AkALNInttUIAAyLMAXbAolg");
        this.shape.setTransform(74.975, 129.925);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.blue_t, new cjs.Rectangle(0, 0, 150, 259.9), null); // stage content:

      (lib.triangle = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // blue

        this.instance = new lib.blue_t();
        this.instance.setTransform(257.95, 304.75, 0.7845, 0.7845, -123.5259, 0, 0, -0.1, 173.3);
        this.instance.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance).to({
          regX: 0,
          regY: 173.2,
          scaleX: 1,
          scaleY: 1,
          rotation: 0,
          x: 250.05,
          y: 273.3
        }, 39).to({
          regX: -0.1,
          regY: 173.3,
          rotation: 239.9996,
          x: 249.45,
          y: 272.7
        }, 120).to({
          regY: 173.2,
          rotation: 479.9989,
          x: 249.15,
          y: 273.5
        }, 120).to({
          regX: 0,
          rotation: 720,
          x: 250.05,
          y: 273.3
        }, 120).to({
          regX: -0.1,
          regY: 173.3,
          rotation: 959.9996,
          x: 249.45,
          y: 272.7
        }, 125).to({
          regY: 173.2,
          rotation: 1199.9989,
          x: 249.15,
          y: 273.5
        }, 126).to({
          regY: 173.3,
          scaleX: 0.7845,
          scaleY: 0.7845,
          rotation: 1316.4741,
          x: 257.95,
          y: 304.75
        }, 40).wait(1)); // yellow

        this.instance_1 = new lib.yellow_t();
        this.instance_1.setTransform(239.65, 289.1, 0.7845, 0.7845, -116.0397, 0, 0, 150, 173.4);
        this.instance_1.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance_1).to({
          regX: 150.1,
          regY: 173.2,
          scaleX: 1,
          scaleY: 1,
          rotation: 0,
          x: 250.1,
          y: 273.3
        }, 39).to({
          regX: 150,
          rotation: 239.9996,
          x: 249.35,
          y: 272.65
        }, 120).to({
          rotation: 479.9989,
          x: 249.1,
          y: 273.55
        }, 120).to({
          regX: 150.1,
          rotation: 720,
          x: 250.1,
          y: 273.3
        }, 120).to({
          regX: 150,
          rotation: 959.9996,
          x: 249.35,
          y: 272.65
        }, 125).to({
          rotation: 1199.9989,
          x: 249.1,
          y: 273.55
        }, 126).to({
          regY: 173.4,
          scaleX: 0.7845,
          scaleY: 0.7845,
          rotation: 1323.9603,
          x: 239.65,
          y: 289.1
        }, 40).wait(1)); // green

        this.instance_2 = new lib.green_t();
        this.instance_2.setTransform(231.5, 315.4, 0.7844, 0.7844, -145.3034, 0, 0, 150, -28.4);
        this.instance_2.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance_2).to({
          regX: 150.1,
          scaleX: 1,
          scaleY: 1,
          rotation: 0,
          x: 250.1,
          y: 273.35
        }, 39).to({
          regX: 150,
          rotation: 239.9996,
          x: 249.35,
          y: 272.65
        }, 120).to({
          rotation: 479.9989,
          x: 249.1,
          y: 273.55
        }, 120).to({
          regX: 150.1,
          rotation: 720,
          x: 250.1,
          y: 273.35
        }, 120).to({
          regX: 150,
          rotation: 959.9996,
          x: 249.35,
          y: 272.65
        }, 125).to({
          rotation: 1199.9989,
          x: 249.1,
          y: 273.55
        }, 126).to({
          scaleX: 0.7844,
          scaleY: 0.7844,
          rotation: 1294.6966,
          x: 231.5,
          y: 315.4
        }, 40).wait(1));

        this._renderFirstFrame();
      }).prototype = p = new lib.AnMovieClip();
      p.nominalBounds = new cjs.Rectangle(274.4, 349.5, 199.70000000000005, 140.60000000000002); // library properties:

      lib.properties = {
        id: '68474CA55B234B77B76FF72360C1BCE2',
        width: 500,
        height: 500,
        fps: 24,
        color: "#FFFFFF",
        opacity: 0.00,
        manifest: [],
        preloads: []
      }; // bootstrap callback support:

      (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
      }).prototype = p = new createjs.Stage();

      p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
      };

      p.play = function () {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
      };

      p.stop = function (ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
      };

      p.seek = function (ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
      };

      p.getDuration = function () {
        return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
      };

      p.getTimelinePosition = function () {
        return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
      };

      an.bootcompsLoaded = an.bootcompsLoaded || [];

      if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
      }

      an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);

        if (an.bootcompsLoaded.length > 0) {
          for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
            fnCallback(an.bootcompsLoaded[i]);
          }
        }
      };

      an.compositions = an.compositions || {};
      an.compositions['68474CA55B234B77B76FF72360C1BCE2'] = {
        getStage: function getStage() {
          return exportRoot.stage;
        },
        getLibrary: function getLibrary() {
          return lib;
        },
        getSpriteSheet: function getSpriteSheet() {
          return ss;
        },
        getImages: function getImages() {
          return img;
        }
      };

      an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);

        for (var j = 0; j < an.bootstrapListeners.length; j++) {
          an.bootstrapListeners[j](id);
        }
      };

      an.getComposition = function (id) {
        return an.compositions[id];
      };

      an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
        var lastW,
            lastH,
            lastS = 1;
        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        function resizeCanvas() {
          var w = lib.properties.width,
              h = lib.properties.height;
          var iw = window.innerWidth,
              ih = window.innerHeight;
          var pRatio = window.devicePixelRatio || 1,
              xRatio = iw / w,
              yRatio = ih / h,
              sRatio = 1;

          if (isResp) {
            if (respDim == 'width' && lastW == iw || respDim == 'height' && lastH == ih) {
              sRatio = lastS;
            } else if (!isScale) {
              if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 1) {
              sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 2) {
              sRatio = Math.max(xRatio, yRatio);
            }
          }

          domContainers[0].width = w * pRatio * sRatio;
          domContainers[0].height = h * pRatio * sRatio;
          domContainers.forEach(function (container) {
            container.style.width = w * sRatio + 'px';
            container.style.height = h * sRatio + 'px';
          });
          stage.scaleX = pRatio * sRatio;
          stage.scaleY = pRatio * sRatio;
          lastW = iw;
          lastH = ih;
          lastS = sRatio;
          stage.tickOnUpdate = false;
          stage.update();
          stage.tickOnUpdate = true;
        }
      };

      an.handleSoundStreamOnTick = function (event) {
        if (!event.paused) {
          var stageChild = stage.getChildAt(0);

          if (!stageChild.paused || stageChild.ignorePause) {
            stageChild.syncStreamSounds();
          }
        }
      };

      an.handleFilterCache = function (event) {
        if (!event.paused) {
          var target = event.target;

          if (target) {
            if (target.filterCacheList) {
              for (var index = 0; index < target.filterCacheList.length; index++) {
                var cacheInst = target.filterCacheList[index];

                if (cacheInst.startFrame <= target.currentFrame && target.currentFrame <= cacheInst.endFrame) {
                  cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
                }
              }
            }
          }
        }
      };
    })(createjs = createjs || {}, AdobeAn = AdobeAn || {});

    var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

    function init() {
      anim_container = container;
      canvas = anim_container.querySelector("canvas");
      dom_overlay_container = anim_container.querySelector("div");
      var comp = AdobeAn.getComposition("68474CA55B234B77B76FF72360C1BCE2");
      var lib = comp.getLibrary();
      handleComplete({}, comp);
    }

    function handleComplete(evt, comp) {
      //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      var lib = comp.getLibrary();
      var ss = comp.getSpriteSheet();
      exportRoot = new lib.triangle();
      stage = new lib.Stage(canvas); //Registers the "tick" event listener.

      fnStartAnimation = function fnStartAnimation() {
        stage.addChild(exportRoot);
        createjs.Ticker.framerate = lib.properties.fps;
        createjs.Ticker.addEventListener("tick", stage);
      }; //Code to support hidpi screens and responsive scaling.


      AdobeAn.makeResponsive(false, 'both', false, 1, [canvas, anim_container, dom_overlay_container]);
      AdobeAn.compositionLoaded(lib.properties.id);
      fnStartAnimation();
    }

    init();
  };

  ns.square = function (container) {
    (function (cjs, an) {
      var p; // shortcut to reference prototypes

      var lib = {};
      var ss = {};
      var img = {};
      lib.ssMetadata = [];
      (lib.AnMovieClip = function () {
        this.actionFrames = [];
        this.ignorePause = false;

        this.gotoAndPlay = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
        };

        this.play = function () {
          cjs.MovieClip.prototype.play.call(this);
        };

        this.gotoAndStop = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
        };

        this.stop = function () {
          cjs.MovieClip.prototype.stop.call(this);
        };
      }).prototype = p = new cjs.MovieClip(); // symbols:
      // helper functions:

      function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));

        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
      }

      function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
      }

      (lib.yellow_s = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FCC800").s().p("An2p6IPtAAIgzGQIoqAAIAAK9ImQCog");
        this.shape.setTransform(84.178, 106.3942, 1.6747, 1.6747);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.yellow_s, new cjs.Rectangle(0, 0, 168.4, 212.8), null);
      (lib.green_s = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#75BE00").s().p("At8FWIAAoDIGQioIAAEcIPZAAIAAhyIGQEuIAADTg");
        this.shape.setTransform(149.5743, 57.2679, 1.6747, 1.6747);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.green_s, new cjs.Rectangle(0, 0, 299.2, 114.6), null);
      (lib.blue_s = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#00A8DB").s().p("AAQHkIAAtnImvAAIAzmQIMMAAIAAYng");
        this.shape.setTransform(69.6486, 131.975, 1.6747, 1.6747);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.blue_s, new cjs.Rectangle(0, 0, 139.3, 264), null); // stage content:

      (lib.square = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // blue

        this.instance = new lib.blue_s();
        this.instance.setTransform(248.9, 209.55, 0.8614, 0.8614, 114.761, 0, 0, -10.6, 150.5);
        this.instance.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance).to({
          scaleX: 1,
          scaleY: 1,
          rotation: 0,
          x: 250.55,
          y: 251.1
        }, 39).to({
          regX: -10.7,
          regY: 150.4,
          rotation: -242.2861,
          x: 250.25,
          y: 249.55
        }, 130).to({
          regY: 150.3,
          rotation: -449.7368,
          x: 251.55,
          y: 250.8
        }, 140).to({
          regX: -10.6,
          regY: 150.5,
          rotation: -720,
          x: 250.55,
          y: 251.1
        }, 130).to({
          regX: -10.7,
          regY: 150.4,
          rotation: -962.2861,
          x: 250.25,
          y: 249.55
        }, 130).to({
          regY: 150.3,
          rotation: -1169.7368,
          x: 251.55,
          y: 250.8
        }, 130).to({
          regX: -10.6,
          regY: 150.5,
          scaleX: 0.8614,
          scaleY: 0.8614,
          rotation: -1325.239,
          x: 248.9,
          y: 209.55
        }, 40).wait(1)); // green

        this.instance_1 = new lib.green_s();
        this.instance_1.setTransform(267.25, 258.35, 0.8614, 0.8614, 143.4466, 0, 0, 149.3, -34.1);
        this.instance_1.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance_1).to({
          regX: 149.2,
          regY: -34.2,
          scaleX: 1,
          scaleY: 1,
          rotation: 0,
          x: 250.5,
          y: 251.05
        }, 39).to({
          regX: 149.3,
          rotation: -242.2861,
          x: 250.15,
          y: 249.6
        }, 130).to({
          regX: 149.2,
          rotation: -449.7368,
          x: 251.6,
          y: 250.75
        }, 140).to({
          rotation: -720,
          x: 250.5,
          y: 251.05
        }, 130).to({
          regX: 149.3,
          rotation: -962.2861,
          x: 250.15,
          y: 249.6
        }, 130).to({
          regX: 149.2,
          rotation: -1169.7368,
          x: 251.6,
          y: 250.75
        }, 130).to({
          regX: 149.3,
          regY: -34.1,
          scaleX: 0.8614,
          scaleY: 0.8614,
          rotation: -1296.5534,
          x: 267.25,
          y: 258.35
        }, 40).wait(1)); // yellow

        this.instance_2 = new lib.yellow_s();
        this.instance_2.setTransform(241.6, 202.3, 0.8614, 0.8614, 164.998, 0, 0, 149.3, 150.6);
        this.instance_2.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance_2).to({
          regX: 149.2,
          regY: 150.5,
          scaleX: 1,
          scaleY: 1,
          rotation: 0,
          x: 250.5,
          y: 251.1
        }, 39).to({
          regX: 149.3,
          rotation: -242.2861,
          x: 250.1,
          y: 249.6
        }, 130).to({
          regX: 149.2,
          regY: 150.4,
          rotation: -449.7368,
          x: 251.6,
          y: 250.75
        }, 140).to({
          regY: 150.5,
          rotation: -720,
          x: 250.5,
          y: 251.1
        }, 130).to({
          regX: 149.3,
          rotation: -962.2861,
          x: 250.1,
          y: 249.6
        }, 130).to({
          regX: 149.2,
          regY: 150.4,
          rotation: -1169.7368,
          x: 251.6,
          y: 250.75
        }, 130).to({
          regX: 149.3,
          regY: 150.6,
          scaleX: 0.8614,
          scaleY: 0.8614,
          rotation: -1275.002,
          x: 241.6,
          y: 202.3
        }, 40).wait(1));

        this._renderFirstFrame();
      }).prototype = p = new lib.AnMovieClip();
      p.nominalBounds = new cjs.Rectangle(287.9, 283.6, 175.3, 179.59999999999997); // library properties:

      lib.properties = {
        id: '68474CA55B234B77B76FF72360C1BCE2',
        width: 500,
        height: 500,
        fps: 24,
        color: "#FFFFFF",
        opacity: 0.00,
        manifest: [],
        preloads: []
      }; // bootstrap callback support:

      (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
      }).prototype = p = new createjs.Stage();

      p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
      };

      p.play = function () {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
      };

      p.stop = function (ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
      };

      p.seek = function (ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
      };

      p.getDuration = function () {
        return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
      };

      p.getTimelinePosition = function () {
        return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
      };

      an.bootcompsLoaded = an.bootcompsLoaded || [];

      if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
      }

      an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);

        if (an.bootcompsLoaded.length > 0) {
          for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
            fnCallback(an.bootcompsLoaded[i]);
          }
        }
      };

      an.compositions = an.compositions || {};
      an.compositions['68474CA55B234B77B76FF72360C1BCE2'] = {
        getStage: function getStage() {
          return exportRoot.stage;
        },
        getLibrary: function getLibrary() {
          return lib;
        },
        getSpriteSheet: function getSpriteSheet() {
          return ss;
        },
        getImages: function getImages() {
          return img;
        }
      };

      an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);

        for (var j = 0; j < an.bootstrapListeners.length; j++) {
          an.bootstrapListeners[j](id);
        }
      };

      an.getComposition = function (id) {
        return an.compositions[id];
      };

      an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
        var lastW,
            lastH,
            lastS = 1;
        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        function resizeCanvas() {
          var w = lib.properties.width,
              h = lib.properties.height;
          var iw = window.innerWidth,
              ih = window.innerHeight;
          var pRatio = window.devicePixelRatio || 1,
              xRatio = iw / w,
              yRatio = ih / h,
              sRatio = 1;

          if (isResp) {
            if (respDim == 'width' && lastW == iw || respDim == 'height' && lastH == ih) {
              sRatio = lastS;
            } else if (!isScale) {
              if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 1) {
              sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 2) {
              sRatio = Math.max(xRatio, yRatio);
            }
          }

          domContainers[0].width = w * pRatio * sRatio;
          domContainers[0].height = h * pRatio * sRatio;
          domContainers.forEach(function (container) {
            container.style.width = w * sRatio + 'px';
            container.style.height = h * sRatio + 'px';
          });
          stage.scaleX = pRatio * sRatio;
          stage.scaleY = pRatio * sRatio;
          lastW = iw;
          lastH = ih;
          lastS = sRatio;
          stage.tickOnUpdate = false;
          stage.update();
          stage.tickOnUpdate = true;
        }
      };

      an.handleSoundStreamOnTick = function (event) {
        if (!event.paused) {
          var stageChild = stage.getChildAt(0);

          if (!stageChild.paused || stageChild.ignorePause) {
            stageChild.syncStreamSounds();
          }
        }
      };

      an.handleFilterCache = function (event) {
        if (!event.paused) {
          var target = event.target;

          if (target) {
            if (target.filterCacheList) {
              for (var index = 0; index < target.filterCacheList.length; index++) {
                var cacheInst = target.filterCacheList[index];

                if (cacheInst.startFrame <= target.currentFrame && target.currentFrame <= cacheInst.endFrame) {
                  cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
                }
              }
            }
          }
        }
      };
    })(createjs = createjs || {}, AdobeAn = AdobeAn || {});

    var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

    function init() {
      anim_container = container;
      canvas = anim_container.querySelector("canvas");
      dom_overlay_container = anim_container.querySelector("div");
      var comp = AdobeAn.getComposition("68474CA55B234B77B76FF72360C1BCE2");
      var lib = comp.getLibrary();
      handleComplete({}, comp);
    }

    function handleComplete(evt, comp) {
      //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      var lib = comp.getLibrary();
      var ss = comp.getSpriteSheet();
      exportRoot = new lib.square();
      stage = new lib.Stage(canvas); //Registers the "tick" event listener.

      fnStartAnimation = function fnStartAnimation() {
        stage.addChild(exportRoot);
        createjs.Ticker.framerate = lib.properties.fps;
        createjs.Ticker.addEventListener("tick", stage);
      }; //Code to support hidpi screens and responsive scaling.


      AdobeAn.makeResponsive(false, 'both', false, 1, [canvas, anim_container, dom_overlay_container]);
      AdobeAn.compositionLoaded(lib.properties.id);
      fnStartAnimation();
    }

    init();
  };

  ns.circle = function (container) {
    (function (cjs, an) {
      var p; // shortcut to reference prototypes

      var lib = {};
      var ss = {};
      var img = {};
      lib.ssMetadata = [];
      (lib.AnMovieClip = function () {
        this.actionFrames = [];
        this.ignorePause = false;

        this.gotoAndPlay = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
        };

        this.play = function () {
          cjs.MovieClip.prototype.play.call(this);
        };

        this.gotoAndStop = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
        };

        this.stop = function () {
          cjs.MovieClip.prototype.stop.call(this);
        };
      }).prototype = p = new cjs.MovieClip(); // symbols:
      // helper functions:

      function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));

        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
      }

      function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
      }

      (lib.yellow = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#F1C01A").s().p("Am+DfQAAi1BGimQBEigB8h7QB8h8CfhEQCmhGC2AAIAAGQQjMAAiRCRQiQCPAADMQAACDBCB0IlaDIQh4jPAAjwg");
        this.shape.setTransform(75.0049, 112.5354, 1.6793, 1.6793);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.yellow, new cjs.Rectangle(0, 0, 150.1, 225.1), null);
      (lib.green = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#75BE00").s().p("ArEFtIg0gdQlVjJjFlVIJGlQQBuC9C8BvQDCByDgAAQDhAADChyQC8hvBui9IJGFQQjGFWlUDIIg0AdQlJCyl8AAQl7AAlJiyg");
        this.shape.setTransform(129.875, 54.275);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.green, new cjs.Rectangle(0, 0, 259.8, 108.6), null);
      (lib.blue = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#00A8DB").s().p("AggMVQBujAAAjeQAAlWjyjyQjyjzlXAAIAAqgQEyAAEWB2QEMByDPDPQDQDQByENQB2EWAAExQAAGTjJFbg");
        this.shape.setTransform(74.975, 112.525);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.blue, new cjs.Rectangle(0, 0, 150, 225.1), null); // stage content:

      (lib.circle = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // green

        this.instance = new lib.green();
        this.instance.setTransform(254.5, 228.55, 0.9612, 0.9612, 48.1487, 0, 0, 130.2, -41.4);
        this.instance.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance).to({
          regX: 129.9,
          scaleX: 1,
          scaleY: 1,
          rotation: -240.0011,
          x: 250.6,
          y: 255.55
        }, 39).to({
          rotation: -480.0004,
          x: 250.55,
          y: 255.65
        }, 120).to({
          regX: 130,
          rotation: -720,
          x: 250.7,
          y: 255.8
        }, 120).to({
          regX: 129.9,
          rotation: -960.0011,
          x: 250.6,
          y: 255.55
        }, 120).to({
          rotation: -1200.0004,
          x: 250.55,
          y: 255.65
        }, 120).to({
          regX: 130.2,
          scaleX: 0.9612,
          scaleY: 0.9612,
          rotation: -1391.8513,
          x: 254.5,
          y: 228.55
        }, 40).wait(1)); // blue

        this.instance_1 = new lib.blue();
        this.instance_1.setTransform(230.3, 249.2, 0.9612, 0.9612, 59.9206, 0, 0, 0.2, 150.1);
        this.instance_1.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance_1).to({
          regX: 0,
          scaleX: 1,
          scaleY: 1,
          rotation: -240.0011,
          x: 250.55,
          y: 255.5
        }, 39).to({
          regX: 0.1,
          rotation: -480.0004,
          y: 255.55
        }, 120).to({
          rotation: -720,
          x: 250.7,
          y: 255.85
        }, 120).to({
          regX: 0,
          rotation: -960.0011,
          x: 250.55,
          y: 255.5
        }, 120).to({
          regX: 0.1,
          rotation: -1200.0004,
          y: 255.55
        }, 120).to({
          regX: 0.2,
          scaleX: 0.9612,
          scaleY: 0.9612,
          rotation: -1380.0794,
          x: 230.3,
          y: 249.2
        }, 40).wait(1)); // yellow

        this.instance_2 = new lib.yellow();
        this.instance_2.setTransform(250.45, 295.75, 0.9612, 0.9612, 52.4399, 0, 0, 150.2, 150);
        this.instance_2.alpha = 0.1016;
        this.timeline.addTween(cjs.Tween.get(this.instance_2).to({
          regX: 150.1,
          scaleX: 1,
          scaleY: 1,
          rotation: -240.0011,
          x: 250.6,
          y: 255.6
        }, 39).to({
          regY: 150.1,
          rotation: -480.0004,
          y: 255.55
        }, 120).to({
          regX: 150.2,
          rotation: -720,
          x: 250.75,
          y: 255.85
        }, 120).to({
          regX: 150.1,
          regY: 150,
          rotation: -960.0011,
          x: 250.6,
          y: 255.6
        }, 120).to({
          regY: 150.1,
          rotation: -1200.0004,
          y: 255.55
        }, 120).to({
          regX: 150.2,
          regY: 150,
          scaleX: 0.9612,
          scaleY: 0.9612,
          rotation: -1387.5601,
          x: 250.45,
          y: 295.75
        }, 40).wait(1));

        this._renderFirstFrame();
      }).prototype = p = new lib.AnMovieClip();
      p.nominalBounds = new cjs.Rectangle(295.7, 318.1, 159.90000000000003, 142.5); // library properties:

      lib.properties = {
        id: '68474CA55B234B77B76FF72360C1BCE2',
        width: 500,
        height: 500,
        fps: 24,
        color: "#FFFFFF",
        opacity: 0.00,
        manifest: [],
        preloads: []
      }; // bootstrap callback support:

      (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
      }).prototype = p = new createjs.Stage();

      p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
      };

      p.play = function () {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
      };

      p.stop = function (ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
      };

      p.seek = function (ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
      };

      p.getDuration = function () {
        return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
      };

      p.getTimelinePosition = function () {
        return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
      };

      an.bootcompsLoaded = an.bootcompsLoaded || [];

      if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
      }

      an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);

        if (an.bootcompsLoaded.length > 0) {
          for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
            fnCallback(an.bootcompsLoaded[i]);
          }
        }
      };

      an.compositions = an.compositions || {};
      an.compositions['68474CA55B234B77B76FF72360C1BCE2'] = {
        getStage: function getStage() {
          return exportRoot.stage;
        },
        getLibrary: function getLibrary() {
          return lib;
        },
        getSpriteSheet: function getSpriteSheet() {
          return ss;
        },
        getImages: function getImages() {
          return img;
        }
      };

      an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);

        for (var j = 0; j < an.bootstrapListeners.length; j++) {
          an.bootstrapListeners[j](id);
        }
      };

      an.getComposition = function (id) {
        return an.compositions[id];
      };

      an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
        var lastW,
            lastH,
            lastS = 1;
        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        function resizeCanvas() {
          var w = lib.properties.width,
              h = lib.properties.height;
          var iw = window.innerWidth,
              ih = window.innerHeight;
          var pRatio = window.devicePixelRatio || 1,
              xRatio = iw / w,
              yRatio = ih / h,
              sRatio = 1;

          if (isResp) {
            if (respDim == 'width' && lastW == iw || respDim == 'height' && lastH == ih) {
              sRatio = lastS;
            } else if (!isScale) {
              if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 1) {
              sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 2) {
              sRatio = Math.max(xRatio, yRatio);
            }
          }

          domContainers[0].width = w * pRatio * sRatio;
          domContainers[0].height = h * pRatio * sRatio;
          domContainers.forEach(function (container) {
            container.style.width = w * sRatio + 'px';
            container.style.height = h * sRatio + 'px';
          });
          stage.scaleX = pRatio * sRatio;
          stage.scaleY = pRatio * sRatio;
          lastW = iw;
          lastH = ih;
          lastS = sRatio;
          stage.tickOnUpdate = false;
          stage.update();
          stage.tickOnUpdate = true;
        }
      };

      an.handleSoundStreamOnTick = function (event) {
        if (!event.paused) {
          var stageChild = stage.getChildAt(0);

          if (!stageChild.paused || stageChild.ignorePause) {
            stageChild.syncStreamSounds();
          }
        }
      };

      an.handleFilterCache = function (event) {
        if (!event.paused) {
          var target = event.target;

          if (target) {
            if (target.filterCacheList) {
              for (var index = 0; index < target.filterCacheList.length; index++) {
                var cacheInst = target.filterCacheList[index];

                if (cacheInst.startFrame <= target.currentFrame && target.currentFrame <= cacheInst.endFrame) {
                  cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
                }
              }
            }
          }
        }
      };
    })(createjs = createjs || {}, AdobeAn = AdobeAn || {});

    var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

    function init() {
      anim_container = container;
      canvas = anim_container.querySelector("canvas");
      dom_overlay_container = anim_container.querySelector("div");
      var comp = AdobeAn.getComposition("68474CA55B234B77B76FF72360C1BCE2");
      var lib = comp.getLibrary();
      handleComplete({}, comp);
    }

    function handleComplete(evt, comp) {
      //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      var lib = comp.getLibrary();
      var ss = comp.getSpriteSheet();
      exportRoot = new lib.circle();
      stage = new lib.Stage(canvas); //Registers the "tick" event listener.

      fnStartAnimation = function fnStartAnimation() {
        stage.addChild(exportRoot);
        createjs.Ticker.framerate = lib.properties.fps;
        createjs.Ticker.addEventListener("tick", stage);
      }; //Code to support hidpi screens and responsive scaling.


      AdobeAn.makeResponsive(false, 'both', false, 1, [canvas, anim_container, dom_overlay_container]);
      AdobeAn.compositionLoaded(lib.properties.id);
      fnStartAnimation();
    }

    init();
  };

  ns.intro = function () {
    (function (cjs, an) {
      var p; // shortcut to reference prototypes

      var lib = {};
      var ss = {};
      var img = {};
      lib.ssMetadata = [];
      (lib.AnMovieClip = function () {
        this.actionFrames = [];
        this.ignorePause = false;

        this.gotoAndPlay = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndPlay.call(this, positionOrLabel);
        };

        this.play = function () {
          cjs.MovieClip.prototype.play.call(this);
        };

        this.gotoAndStop = function (positionOrLabel) {
          cjs.MovieClip.prototype.gotoAndStop.call(this, positionOrLabel);
        };

        this.stop = function () {
          cjs.MovieClip.prototype.stop.call(this);
        };
      }).prototype = p = new cjs.MovieClip(); // symbols:
      // helper functions:

      function mc_symbol_clone() {
        var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));

        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
      }

      function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        var prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
      }

      (lib.yellow_t = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FCC800").s().p("ALu0SIAASLIntNUIvuJGg");
        this.shape.setTransform(75.025, 129.925);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.yellow_t, new cjs.Rectangle(0, 0, 150.1, 259.9), null);
      (lib.yellow_s = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#FCC800").s().p("An2p6IPtAAIgzGQIoqAAIAAK9ImQCog");
        this.shape.setTransform(84.178, 106.3942, 1.6747, 1.6747);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.yellow_s, new cjs.Rectangle(0, 0, 168.4, 212.8), null);
      (lib.yellow = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#F1C01A").s().p("Am+DfQAAi1BGimQBEigB8h7QB8h8CfhEQCmhGC2AAIAAGQQjMAAiRCRQiQCPAADMQAACDBCB0IlaDIQh4jPAAjwg");
        this.shape.setTransform(75.0049, 112.5354, 1.6793, 1.6793);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.yellow, new cjs.Rectangle(0, 0, 150.1, 225.1), null);
      (lib.green_t = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#75BE00").s().p("A3bEjIPwpFIPYAAIPvJFg");
        this.shape.setTransform(150, 29.1);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.green_t, new cjs.Rectangle(0, 0, 300, 58.2), null);
      (lib.green_s = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#75BE00").s().p("At8FWIAAoDIGQioIAAEcIPZAAIAAhyIGQEuIAADTg");
        this.shape.setTransform(149.5743, 57.2679, 1.6747, 1.6747);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.green_s, new cjs.Rectangle(0, 0, 299.2, 114.6), null);
      (lib.green = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#75BE00").s().p("ArEFtIg0gdQlVjJjFlVIJGlQQBuC9C8BvQDCByDgAAQDhAADChyQC8hvBui9IJGFQQjGFWlUDIIg0AdQlJCyl8AAQl7AAlJiyg");
        this.shape.setTransform(129.875, 54.275);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.green, new cjs.Rectangle(0, 0, 259.8, 108.6), null);
      (lib.blue_t = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#00A8DB").s().p("AkALNInttUIAAyLMAXbAolg");
        this.shape.setTransform(74.975, 129.925);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.blue_t, new cjs.Rectangle(0, 0, 150, 259.9), null);
      (lib.blue_s = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#00A8DB").s().p("AAQHkIAAtnImvAAIAzmQIMMAAIAAYng");
        this.shape.setTransform(69.6486, 131.975, 1.6747, 1.6747);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.blue_s, new cjs.Rectangle(0, 0, 139.3, 264), null);
      (lib.blue = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // レイヤー_1

        this.shape = new cjs.Shape();
        this.shape.graphics.f("#00A8DB").s().p("AggMVQBujAAAjeQAAlWjyjyQjyjzlXAAIAAqgQEyAAEWB2QEMByDPDPQDQDQByENQB2EWAAExQAAGTjJFbg");
        this.shape.setTransform(74.975, 112.525);
        this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

        this._renderFirstFrame();
      }).prototype = getMCSymbolPrototype(lib.blue, new cjs.Rectangle(0, 0, 150, 225.1), null); // stage content:

      (lib.mainbg = function (mode, startPosition, loop, reversed) {
        if (loop == null) {
          loop = true;
        }

        if (reversed == null) {
          reversed = false;
        }

        var props = new Object();
        props.mode = mode;
        props.startPosition = startPosition;
        props.labels = {};
        props.loop = loop;
        props.reversed = reversed;
        cjs.MovieClip.apply(this, [props]); // triangle_blue

        this.instance = new lib.blue_s();
        this.instance.setTransform(629.4, 247.5, 8.9818, 8.9818, -174.0538, 0, 0, -10.5, 150.5);
        this.instance.alpha = 0.4492;
        this.instance._off = true;
        this.timeline.addTween(cjs.Tween.get(this.instance).wait(618).to({
          _off: false
        }, 0).to({
          scaleX: 1.5209,
          scaleY: 1.5209,
          rotation: -339.0545,
          x: 723.4,
          y: 451.65,
          alpha: 0.3008
        }, 30).to({
          rotation: -519.0545,
          x: 724.9,
          y: 449.35
        }, 95).to({
          regX: -10.3,
          scaleX: 1.2015,
          scaleY: 1.2015,
          rotation: -643.5179,
          x: 709.8,
          y: 428.25
        }, 23).to({
          regX: -10.5,
          scaleX: 1.5209,
          scaleY: 1.5209,
          rotation: -789.0545,
          x: 720.7,
          y: 454.95
        }, 24).to({
          rotation: -969.0545,
          x: 718.35,
          y: 453.3
        }, 90).to({
          scaleX: 10.7089,
          scaleY: 10.7089,
          rotation: -1059.0545,
          x: 718.2,
          y: 458.8
        }, 30).wait(16)); // triangle_green

        this.instance_1 = new lib.green_s();
        this.instance_1.setTransform(942.4, 470.65, 8.9818, 8.9818, -169.807, 0, 0, 149.3, -34.1);
        this.instance_1.alpha = 0.4492;
        this.instance_1._off = true;
        this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(618).to({
          _off: false
        }, 0).to({
          scaleX: 1.5209,
          scaleY: 1.5209,
          rotation: -339.0545,
          x: 723.3,
          y: 451.65,
          alpha: 0.3008
        }, 30).to({
          rotation: -519.0545,
          x: 725,
          y: 449.35
        }, 95).to({
          regX: 149.4,
          regY: -34.2,
          scaleX: 1.2015,
          scaleY: 1.2015,
          rotation: -643.5179,
          x: 761.85,
          y: 442.95
        }, 23).to({
          regX: 149.3,
          regY: -34.1,
          scaleX: 1.5209,
          scaleY: 1.5209,
          rotation: -789.0545,
          x: 720.7,
          y: 455.05
        }, 24).to({
          rotation: -969.0545,
          x: 718.35,
          y: 453.2
        }, 90).to({
          scaleX: 10.7089,
          scaleY: 10.7089,
          rotation: -1059.0545,
          x: 717.75,
          y: 459
        }, 30).wait(16)); // triangle_yellow

        this.instance_2 = new lib.yellow_s();
        this.instance_2.setTransform(1182.7, 343.85, 8.9816, 8.9816, -141.0463, 0, 0, 149.3, 150.5);
        this.instance_2.alpha = 0.4492;
        this.instance_2._off = true;
        this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(618).to({
          _off: false
        }, 0).to({
          scaleX: 1.5209,
          scaleY: 1.5209,
          rotation: -339.0545,
          x: 723.35,
          y: 451.6,
          alpha: 0.3008
        }, 30).to({
          rotation: -519.0545,
          x: 724.95,
          y: 449.4
        }, 95).to({
          scaleX: 1.2015,
          scaleY: 1.2015,
          rotation: -652.7231,
          x: 739.7,
          y: 513.35
        }, 23).to({
          scaleX: 1.5209,
          scaleY: 1.5209,
          rotation: -789.0545,
          x: 720.65,
          y: 455
        }, 24).to({
          rotation: -969.0545,
          x: 718.4,
          y: 453.25
        }, 90).to({
          scaleX: 10.7089,
          scaleY: 10.7089,
          rotation: -1059.0545,
          x: 718,
          y: 458.65
        }, 30).wait(16)); // triangle_blue

        this.instance_3 = new lib.blue_t();
        this.instance_3.setTransform(729.2, 359.1, 15.2873, 15.2873, 125.7718, 0, 0, 0.1, 173.3);
        this.instance_3.alpha = 0;
        this.instance_3._off = true;
        this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(304).to({
          _off: false
        }, 0).to({
          scaleX: 2.1316,
          scaleY: 2.1316,
          rotation: 392.4824,
          x: 721.85,
          y: 447.95,
          alpha: 0.3008
        }, 35).to({
          regY: 173.4,
          scaleX: 2.1315,
          scaleY: 2.1315,
          rotation: 512.4813,
          x: 721.3,
          y: 453.35
        }, 90).to({
          regX: -0.1,
          regY: 173.3,
          scaleX: 1.3882,
          scaleY: 1.3882,
          rotation: 605.2257,
          x: 791.4,
          y: 415.85
        }, 24).to({
          regX: 0.1,
          scaleX: 2.1315,
          scaleY: 2.1315,
          rotation: 767.482,
          x: 722.5,
          y: 448.45
        }, 24).to({
          regY: 173.5,
          rotation: 909.4942,
          x: 719.4,
          y: 453.35
        }, 95).to({
          scaleX: 31.6388,
          scaleY: 31.6388,
          rotation: 1029.4942,
          x: 681.15,
          y: 416.6
        }, 30).to({
          _off: true
        }, 1).wait(323)); // triangle_green

        this.instance_4 = new lib.green_t();
        this.instance_4.setTransform(841.85, 898.15, 15.2875, 15.2875, 146.784, 0, 0, 150.2, -28.4);
        this.instance_4.alpha = 0;
        this.instance_4._off = true;
        this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(304).to({
          _off: false
        }, 0).to({
          scaleX: 2.1316,
          scaleY: 2.1316,
          rotation: 392.4824,
          x: 721.9,
          y: 448,
          alpha: 0.3008
        }, 35).to({
          regY: -28.3,
          scaleX: 2.1315,
          scaleY: 2.1315,
          rotation: 512.4813,
          x: 721.2,
          y: 453.45
        }, 90).to({
          regY: -28.4,
          scaleX: 1.3882,
          scaleY: 1.3882,
          rotation: 609.0216,
          x: 718.25,
          y: 445.85
        }, 24).to({
          scaleX: 2.1315,
          scaleY: 2.1315,
          rotation: 767.482,
          x: 722.6,
          y: 448.55
        }, 24).to({
          regX: 150.1,
          regY: -28.3,
          rotation: 909.4942,
          x: 719.45,
          y: 453.7
        }, 95).to({
          scaleX: 31.6388,
          scaleY: 31.6388,
          rotation: 1029.4942,
          x: 676.85,
          y: 415.35
        }, 30).to({
          _off: true
        }, 1).wait(323)); // triangle_yellow

        this.instance_5 = new lib.yellow_t();
        this.instance_5.setTransform(961.95, 1001.9, 15.2874, 15.2874, 133.2632, 0, 0, 150.2, 173.3);
        this.instance_5.alpha = 0;
        this.instance_5._off = true;
        this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(304).to({
          _off: false
        }, 0).to({
          scaleX: 2.1316,
          scaleY: 2.1316,
          rotation: 392.4824,
          x: 721.85,
          y: 448.1,
          alpha: 0.3008
        }, 35).to({
          regX: 150.1,
          scaleX: 2.1315,
          scaleY: 2.1315,
          rotation: 512.4813,
          x: 721.45,
          y: 453.45
        }, 90).to({
          scaleX: 1.3882,
          scaleY: 1.3882,
          rotation: 609.0216,
          x: 754.75,
          y: 440.4
        }, 24).to({
          regY: 173.2,
          scaleX: 2.1315,
          scaleY: 2.1315,
          rotation: 767.482,
          x: 722.55,
          y: 448.45
        }, 24).to({
          regY: 173.4,
          rotation: 909.4942,
          x: 719.45,
          y: 453.55
        }, 95).to({
          scaleX: 31.6388,
          scaleY: 31.6388,
          rotation: 1029.4942,
          x: 678.45,
          y: 416.4
        }, 30).to({
          _off: true
        }, 1).wait(323)); // circle_blue

        this.instance_6 = new lib.blue();
        this.instance_6.setTransform(726.55, 542.95, 11.4952, 11.4952, -119.8066, 0, 0, 0.1, 150.1);
        this.instance_6.alpha = 0;
        this.timeline.addTween(cjs.Tween.get(this.instance_6).to({
          scaleX: 2.1333,
          scaleY: 2.1333,
          rotation: -360,
          x: 720.35,
          y: 450.2,
          alpha: 0.3008
        }, 29).to({
          rotation: -480.0003,
          x: 720,
          y: 449.5
        }, 90).to({
          scaleX: 1.446,
          scaleY: 1.446,
          rotation: -684.2099,
          x: 678.6,
          y: 432.75
        }, 25).to({
          scaleX: 2.1333,
          scaleY: 2.1333,
          rotation: -840.0003,
          x: 720,
          y: 449.5
        }, 25).to({
          rotation: -1020.0003,
          y: 451.8
        }, 90).to({
          scaleX: 10.4719,
          scaleY: 10.4719,
          rotation: -1200.0003,
          x: 720.15,
          y: 444.95
        }, 30).to({
          _off: true
        }, 1).wait(636)); // circle_green

        this.instance_7 = new lib.green();
        this.instance_7.setTransform(573.05, 412.05, 11.4954, 11.4954, -160.498, 0, 0, 130, -41.4);
        this.instance_7.alpha = 0;
        this.timeline.addTween(cjs.Tween.get(this.instance_7).to({
          scaleX: 2.1333,
          scaleY: 2.1333,
          rotation: -360,
          x: 720.35,
          y: 450.15,
          alpha: 0.3008
        }, 29).to({
          rotation: -480.0003,
          x: 719.95,
          y: 449.6
        }, 90).to({
          scaleX: 1.446,
          scaleY: 1.446,
          rotation: -665.762,
          x: 758.95,
          y: 407
        }, 25).to({
          scaleX: 2.1333,
          scaleY: 2.1333,
          rotation: -840.0003,
          x: 719.95,
          y: 449.6
        }, 25).to({
          rotation: -1020.0003,
          x: 720.05,
          y: 451.7
        }, 90).to({
          scaleX: 10.4719,
          scaleY: 10.4719,
          rotation: -1200.0003,
          x: 719.75,
          y: 445.3
        }, 30).to({
          _off: true
        }, 1).wait(636)); // circle_yellow

        this.instance_8 = new lib.yellow();
        this.instance_8.setTransform(662.05, 382.65, 11.4952, 11.4952, -134.8067, 0, 0, 150.2, 150.1);
        this.instance_8.alpha = 0;
        this.timeline.addTween(cjs.Tween.get(this.instance_8).to({
          scaleX: 2.1333,
          scaleY: 2.1333,
          rotation: -360,
          x: 720.45,
          y: 450.2,
          alpha: 0.3008
        }, 29).to({
          regX: 150.1,
          rotation: -480.0003,
          x: 720.05,
          y: 449.65
        }, 90).to({
          scaleX: 1.446,
          scaleY: 1.446,
          rotation: -660.0001,
          x: 728.65,
          y: 491.7
        }, 25).to({
          scaleX: 2.1333,
          scaleY: 2.1333,
          rotation: -840.0003,
          x: 720.05,
          y: 449.65
        }, 25).to({
          rotation: -1020.0003,
          x: 719.95,
          y: 451.65
        }, 90).to({
          scaleX: 10.4719,
          scaleY: 10.4719,
          rotation: -1200.0003,
          x: 720.3,
          y: 445.55
        }, 30).to({
          _off: true
        }, 1).wait(636));

        this._renderFirstFrame();
      }).prototype = p = new lib.AnMovieClip();
      p.nominalBounds = new cjs.Rectangle(-5855.5, -6283.3, 11660.7, 12104.1); // library properties:

      lib.properties = {
        id: '40011AD5552F48408F684A4DD607C2A3',
        width: 1440,
        height: 900,
        fps: 24,
        color: "#F7FBFF",
        opacity: 0.00,
        manifest: [],
        preloads: []
      }; // bootstrap callback support:

      (lib.Stage = function (canvas) {
        createjs.Stage.call(this, canvas);
      }).prototype = p = new createjs.Stage();

      p.setAutoPlay = function (autoPlay) {
        this.tickEnabled = autoPlay;
      };

      p.play = function () {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
      };

      p.stop = function (ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
      };

      p.seek = function (ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000);
      };

      p.getDuration = function () {
        return this.getChildAt(0).totalFrames / lib.properties.fps * 1000;
      };

      p.getTimelinePosition = function () {
        return this.getChildAt(0).currentFrame / lib.properties.fps * 1000;
      };

      an.bootcompsLoaded = an.bootcompsLoaded || [];

      if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
      }

      an.bootstrapCallback = function (fnCallback) {
        an.bootstrapListeners.push(fnCallback);

        if (an.bootcompsLoaded.length > 0) {
          for (var i = 0; i < an.bootcompsLoaded.length; ++i) {
            fnCallback(an.bootcompsLoaded[i]);
          }
        }
      };

      an.compositions = an.compositions || {};
      an.compositions['40011AD5552F48408F684A4DD607C2A3'] = {
        getStage: function getStage() {
          return exportRoot.stage;
        },
        getLibrary: function getLibrary() {
          return lib;
        },
        getSpriteSheet: function getSpriteSheet() {
          return ss;
        },
        getImages: function getImages() {
          return img;
        }
      };

      an.compositionLoaded = function (id) {
        an.bootcompsLoaded.push(id);

        for (var j = 0; j < an.bootstrapListeners.length; j++) {
          an.bootstrapListeners[j](id);
        }
      };

      an.getComposition = function (id) {
        return an.compositions[id];
      };

      an.makeResponsive = function (isResp, respDim, isScale, scaleType, domContainers) {
        var lastW,
            lastH,
            lastS = 1;
        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        function resizeCanvas() {
          var w = lib.properties.width,
              h = lib.properties.height;
          var iw = window.innerWidth,
              ih = window.innerHeight;
          var pRatio = window.devicePixelRatio || 1,
              xRatio = iw / w,
              yRatio = ih / h,
              sRatio = 1;

          if (isResp) {
            if (respDim == 'width' && lastW == iw || respDim == 'height' && lastH == ih) {
              sRatio = lastS;
            } else if (!isScale) {
              if (iw < w || ih < h) sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 1) {
              sRatio = Math.min(xRatio, yRatio);
            } else if (scaleType == 2) {
              sRatio = Math.max(xRatio, yRatio);
            }
          }

          domContainers[0].width = w * pRatio * sRatio;
          domContainers[0].height = h * pRatio * sRatio;
          domContainers.forEach(function (container) {
            container.style.width = w * sRatio + 'px';
            container.style.height = h * sRatio + 'px';
          });
          stage.scaleX = pRatio * sRatio;
          stage.scaleY = pRatio * sRatio;
          lastW = iw;
          lastH = ih;
          lastS = sRatio;
          stage.tickOnUpdate = false;
          stage.update();
          stage.tickOnUpdate = true;
        }
      };

      an.handleSoundStreamOnTick = function (event) {
        if (!event.paused) {
          var stageChild = stage.getChildAt(0);

          if (!stageChild.paused || stageChild.ignorePause) {
            stageChild.syncStreamSounds();
          }
        }
      };

      an.handleFilterCache = function (event) {
        if (!event.paused) {
          var target = event.target;

          if (target) {
            if (target.filterCacheList) {
              for (var index = 0; index < target.filterCacheList.length; index++) {
                var cacheInst = target.filterCacheList[index];

                if (cacheInst.startFrame <= target.currentFrame && target.currentFrame <= cacheInst.endFrame) {
                  cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
                }
              }
            }
          }
        }
      };
    })(createjs = createjs || {}, AdobeAn = AdobeAn || {});

    var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

    function init() {
      canvas = document.getElementById("canvas");
      anim_container = document.getElementById("animation_container");
      dom_overlay_container = document.getElementById("dom_overlay_container");
      var comp = AdobeAn.getComposition("40011AD5552F48408F684A4DD607C2A3");
      var lib = comp.getLibrary();
      handleComplete({}, comp);
    }

    function handleComplete(evt, comp) {
      //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      var lib = comp.getLibrary();
      var ss = comp.getSpriteSheet();
      exportRoot = new lib.mainbg();
      stage = new lib.Stage(canvas); //Registers the "tick" event listener.

      fnStartAnimation = function fnStartAnimation() {
        stage.addChild(exportRoot);
        createjs.Ticker.framerate = lib.properties.fps;
        createjs.Ticker.addEventListener("tick", stage);
      }; //Code to support hidpi screens and responsive scaling.


      AdobeAn.makeResponsive(false, 'both', false, 1, [canvas, anim_container, dom_overlay_container]);
      AdobeAn.compositionLoaded(lib.properties.id);
      fnStartAnimation();
    }

    init();
  };

  ns.init = function () {
    var shapes = document.querySelectorAll('.animation_container');
    shapes.forEach(function (shape) {
      var delay = Math.random() * 1000;

      var func = function func() {};

      switch (true) {
        case shape.classList.contains('--triangle'):
          func = PUNITED.animation.triangle;
          break;

        case shape.classList.contains('--square'):
          func = PUNITED.animation.square;
          break;

        case shape.classList.contains('--circle'):
          func = PUNITED.animation.circle;
      }

      setTimeout(func, delay, shape);
    });
  };
})();

$(function () {
  PUNITED.animation.init();
});